/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../../../api/types.generated";
export type CheckIntoShiftMutationVariables = Types.Exact<{
  shift_id: Types.Scalars["Int"];
  event_attendee_id: Types.Scalars["Int"];
}>;

export type CheckIntoShiftMutation = {
  checkInToShift: Pick<Types.ShiftSignup, "event_attendee_id" | "checked_in">;
};

export const CheckIntoShiftDocument = gql`
  mutation CheckIntoShift($shift_id: Int!, $event_attendee_id: Int!) {
    checkInToShift(shift_id: $shift_id, event_attendee_id: $event_attendee_id) {
      event_attendee_id
      checked_in
    }
  }
`;

/**
 * __useCheckIntoShiftMutation__
 *
 * To run a mutation, you first call `useCheckIntoShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckIntoShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkIntoShiftMutation, { data, loading, error }] = useCheckIntoShiftMutation({
 *   variables: {
 *      shift_id: // value for 'shift_id'
 *      event_attendee_id: // value for 'event_attendee_id'
 *   },
 * });
 */
export function useCheckIntoShiftMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CheckIntoShiftMutation,
    CheckIntoShiftMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    CheckIntoShiftMutation,
    CheckIntoShiftMutationVariables
  >(CheckIntoShiftDocument, baseOptions);
}
export type CheckIntoShiftMutationHookResult = ReturnType<
  typeof useCheckIntoShiftMutation
>;
export type CheckIntoShiftMutationResult =
  ApolloReactCommon.MutationResult<CheckIntoShiftMutation>;
export type CheckIntoShiftMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CheckIntoShiftMutation,
    CheckIntoShiftMutationVariables
  >;
